import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const STAGE_COLORS = {
  new: '#3B82F6',
  contacted: '#8B5CF6',
  qualified: '#F59E0B',
  proposal_sent: '#F97316',
  negotiating: '#6366F1',
  won: '#22C55E',
  lost: '#EF4444',
  on_hold: '#9CA3AF',
};

const ConversionFunnelChart = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-muted-foreground text-sm">
        No pipeline data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
        <XAxis dataKey="name" tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
        <Tooltip formatter={(value) => [value, 'Prospects']} />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {data?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={STAGE_COLORS?.[entry?.key] || '#F39C12'} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConversionFunnelChart;
